import { Sidebar } from "./Sidebar";

export const DashboardLayout = ({ children, userType }) => {
  return (
    <div className="min-h-screen flex bg-[#F4F4F5]">
      <Sidebar userType={userType} />
      <main className="flex-1 min-h-screen overflow-auto">
        <div className="p-6 lg:p-8">
          {children}
        </div>
      </main>
    </div>
  );
};
